export class WebhookV1AnomalyGraphData {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "dataPoints",
            "baseName": "data_points",
            "type": "Array<WebhookV1AnomalyDataPoint>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1AnomalyGraphData.attributeTypeMap;
    }
    constructor() {
    }
}
